"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontFamilies = exports.LineHeights = exports.MediaQueries = exports.Durations = exports.ZIndices = exports.Spacing = exports.Shadows = exports.Radii = exports.Opacities = exports.LetterSpacings = exports.FontWeights = exports.FontSizes = exports.Colors = exports.BorderWidths = void 0;
// importing the following files here so we can modify its values before exporting them
// export { default as FontFamilies } from "./figmagic/fontFamilies"
const lineHeights_1 = __importDefault(require("./figmagic/lineHeights"));
var borderWidths_1 = require("./figmagic/borderWidths");
Object.defineProperty(exports, "BorderWidths", { enumerable: true, get: function () { return __importDefault(borderWidths_1).default; } });
var colors_1 = require("./figmagic/colors");
Object.defineProperty(exports, "Colors", { enumerable: true, get: function () { return __importDefault(colors_1).default; } });
var fontSizes_1 = require("./figmagic/fontSizes");
Object.defineProperty(exports, "FontSizes", { enumerable: true, get: function () { return __importDefault(fontSizes_1).default; } });
var fontWeights_1 = require("./figmagic/fontWeights");
Object.defineProperty(exports, "FontWeights", { enumerable: true, get: function () { return __importDefault(fontWeights_1).default; } });
var letterSpacings_1 = require("./figmagic/letterSpacings");
Object.defineProperty(exports, "LetterSpacings", { enumerable: true, get: function () { return __importDefault(letterSpacings_1).default; } });
var opacities_1 = require("./figmagic/opacities");
Object.defineProperty(exports, "Opacities", { enumerable: true, get: function () { return __importDefault(opacities_1).default; } });
var radii_1 = require("./figmagic/radii");
Object.defineProperty(exports, "Radii", { enumerable: true, get: function () { return __importDefault(radii_1).default; } });
var shadows_1 = require("./figmagic/shadows");
Object.defineProperty(exports, "Shadows", { enumerable: true, get: function () { return __importDefault(shadows_1).default; } });
var spacing_1 = require("./figmagic/spacing");
Object.defineProperty(exports, "Spacing", { enumerable: true, get: function () { return __importDefault(spacing_1).default; } });
var zIndices_1 = require("./figmagic/zIndices");
Object.defineProperty(exports, "ZIndices", { enumerable: true, get: function () { return __importDefault(zIndices_1).default; } });
var durations_1 = require("./figmagic/durations");
Object.defineProperty(exports, "Durations", { enumerable: true, get: function () { return __importDefault(durations_1).default; } });
var mediaQueries_1 = require("./figmagic/mediaQueries");
Object.defineProperty(exports, "MediaQueries", { enumerable: true, get: function () { return __importDefault(mediaQueries_1).default; } });
/** Convert line height values to rem */
const LineHeights = {}; // because we are adding additional properties to this object, we need this object type to be 'any'
exports.LineHeights = LineHeights;
const lineHeightKeys = Object.keys(lineHeights_1.default);
for (let i = 0; i < lineHeightKeys.length; i += 1) {
    const key = lineHeightKeys[i];
    LineHeights[key] = `${Number(lineHeights_1.default[key])}rem`;
}
const systemFontStack = `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`;
// fonts are hard-coded because Figmagic didn't export them correctly
exports.FontFamilies = {
    montserrat: `"Montserrat", ${systemFontStack}`,
    merriweather: `"Merriweather", Georgia, "Times New Roman", Times, serif`,
    openSans: `"Open Sans", ${systemFontStack}`,
};
//# sourceMappingURL=index.js.map